import { render, staticRenderFns } from "./closeX.vue?vue&type=template&id=28491b10&scoped=true"
import script from "./closeX.vue?vue&type=script&lang=js"
export * from "./closeX.vue?vue&type=script&lang=js"
import style0 from "./closeX.vue?vue&type=style&index=0&id=28491b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28491b10",
  null
  
)

export default component.exports